import axios from 'axios';

import * as constants from '../utils/constants';
import * as models from '../utils/models';
import * as offlineService from './offlineService';
import * as toastService from './toastService';

const instance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	timeout: constants.NETWORK_TIMEOUT,
});

const setToken = (token: string): void => {
	instance.defaults.headers.common['x-access-token'] = token;
};

const checkNonCacheableURL = (url: string) => {
	return [process.env.REACT_APP_CLOUDINARY_API, `${process.env.REACT_APP_OFFICIAL_URL}`].some((nonCachebleURL) => nonCachebleURL?.indexOf(url) !== -1);
};

instance.interceptors.request.use(
	(request: models.Request) => {
		const { method, url } = request;

		const requests: string[] = ['post', 'put', 'patch'];

		const isLoginEndpoint: boolean = url === constants.LOGIN_ENDPOINT;
		const isNotCacheable = requests.indexOf(method as string) === -1;

		if (
			!navigator.onLine &&
			!checkNonCacheableURL(url as string) &&
			!isLoginEndpoint &&
			!isNotCacheable
		) {
			toastService.promise(offlineService.addToQueue(request), {
				loading: 'Saving action',
				success: (message: string) => message,
				error: () => 'Could not save the action',
			});
		}

		return request;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// eslint-disable-next-line
export default {
	get: instance.get,
	post: instance.post,
	patch: instance.patch,
	put: instance.put,
	delete: instance.delete,
	request: instance.request,
	setToken,
};
